// stores/website.ts
import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { websiteRepository, type InitializationResponse } from '~/utils/websiteRepository'

export const useWebsiteStore = defineStore('website', () => {
  // نستخدم useCookie لتخزين بيانات التهيئة بشكل دائم
  const cookieData = useCookie<InitializationResponse['data']>('initializationData', {
    default: () => null
  })

  // الحالة: إذا كانت البيانات موجودة في الكوكيز، نستخدمها كبداية
  const initializationData = ref<InitializationResponse['data'] | null>(cookieData.value)
  
  // Actions
  async function fetchInitializationData() {

    // 1) الحصول على $api من Nuxt App context
    const { $api } = useNuxtApp()

    // 2) استخدام الـ repository لجلب البيانات
    const repo = websiteRepository($api)
    const response = await repo.getInitialization()

    // 3) تخزين البيانات في الحالة وتحديث الكوكيز
    initializationData.value = response.data
    cookieData.value = response.data
  }

  // Getters (اختياري) للوصول بسهولة لاسم وأيقونة الموقع
  const websiteName = computed(() => initializationData.value?.application_settings?.app_name ?? '')
  const websiteIcon = computed(() => initializationData.value?.application_settings?.app_icon ?? '')

  return {
    initializationData,
    websiteName,
    websiteIcon,
    fetchInitializationData
  }
})
